const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    plant: {},
    plantPending: false,
    plantUpdatePendings: [],
    plantError: null,

    plants: [],
    plantsPending: false,
    plantsError: null,
  },
  mutations: {
    // plant
    setPlant (state, value) {
      state.plant = value
    },
    createPlant (state, value) {
      state.plants.unshift(value)
    },
    updatePlant (state, value) {
      state.plant = { ...state.plant, ...value } 
    },
    deletePlant (state, value) {
      state.plants = state.plants.filter(function (p) {
        return p.id !== value.id;
      });
    },
    setPlantPending (state, value) {
      state.plantPending = value
    },
    setPlantError (state, value) {
      state.plantError = value
    },
    // plants
    setPlants (state, value) {
      state.plants = value
    },
    updatePlants (state, value) {
      state.plants = state.plants.map(el => el.id === state.plant.id ? {...el, ...value} : el)
    },
    setPlantsPending (state, value) {
      state.plantsPending = value
    },
    setPlantsError (state, value) {
      state.plantsError = value
    },
  },
  actions: {
    createPlant ({ commit, rootState }, payload) {
      let newPlant = {
        createdAt: fb.firebase.firestore.Timestamp.now(),
        updatedAt: fb.firebase.firestore.Timestamp.now(),
        pictureUrl: payload.pictureUrl,
        pictureName: payload.pictureName,
        numberOfLovers: 0,
        userId: fb.firebase.auth().currentUser.uid,
        loversId: []
      }
      if (rootState.self.self.profilePictureUrl) newPlant.userProfilePictureUrl = rootState.self.self.profilePictureUrl;
      if (rootState.self.self.nickname) newPlant.userNickname = rootState.self.self.nickname;
      if (payload.status) newPlant.status = payload.status;

      fb.db.collection("plants").doc(fb.firebase.auth().currentUser.uid).collection("plants").add(newPlant).then(data =>{
        commit("createPlant", { id: data.id, ...newPlant })
      })
      commit(`snackbar/setSnackbar`, {
        active: false,color: "info"
      },{ root: true });
    },
    getPlants({state, commit, rootState}, gardenId){
      commit('setPlantsPending', true)
      fb.db.collection("plants").doc(gardenId).collection("plants").orderBy("updatedAt", "desc")
        .get()
        .then((querySnapshot) => {
          let plants = []
          querySnapshot.forEach((doc) => {
            plants.push({ id: doc.id, ...doc.data() })
          });
          commit('setPlants', plants)
          commit('setPlantsPending', false)
        })
        .catch((error) => {
          commit('setPlantsPending', false)
          commit('setPlantsError', error)
        })
    },
    deletePlant ({ commit }, plant) {
      commit("deletePlant", plant)
      fb.db.collection("plants").doc(fb.firebase.auth().currentUser.uid).collection("plants").doc(plant.id).delete()
    },
    getPlant({ commit }, payload){
      commit('setPlant', {})
      commit('setPlantPending', true)
      fb.db.collection("plants").doc(payload.gardenId).collection("plants").doc(payload.plantId).get().then((doc) => {
        if (doc.exists) {
          commit('setPlant', { id: doc.id, ...doc.data() })
        } else {
          return console.log("No such document!");
        }
        commit('setPlantPending', false)

      }).catch((error) => {
        commit('setPlantError', error)
        commit('setPlantPending', false)
      });
    },
    updatePlant({ state, commit }, update){
      commit("updatePlant", update)
      commit("updatePlants", update)
      commit('setPlantPending', true)
      fb.db.collection("plants").doc(fb.firebase.auth().currentUser.uid).collection("plants").doc(state.plant.id).update({updatedAt: fb.firebase.firestore.Timestamp.now(),...update}).then(()=>{
        commit('setPlantPending', false)
      }).catch((error) => {
        commit('setPlantError', error)
        commit('setPlantPending', false)
      });
    },
    uploadPlantPicture({ commit, dispatch }, params) {
      commit(`snackbar/setSnackbar`, {
        color: "info",
        timeout: 16000,
        text: "Your new plant is being loaded",
        loading: true
      },{ root: true });
      commit('setPlantPending', true)
      let pictureName = fb.firebase.auth().currentUser.uid + "_" + fb.firebase.firestore.Timestamp.now()
      var uploadTask = fb.firebase
        .storage()
        .ref("/plantPictures")
        .child(pictureName)
        .putString(params.picture, "data_url");
      uploadTask.on(
        "state_changed",
        function(snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case fb.firebase.storage.TaskState.PAUSED: // or 'paused'
              // console.log("Upload is paused");
              break;
            case fb.firebase.storage.TaskState.RUNNING: // or 'running'
              // console.log("Upload is running");
              break;
          }
        },
        function(error) {
          // Handle unsuccessful uploads
        },
        function() {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            let newPlant = {pictureUrl: downloadURL, pictureName }
            if(params.status) newPlant.status = params.status
            dispatch("createPlant", newPlant)
          });
        }
      );
    },
    modifyPlantPicture({ state, commit, dispatch }, picture) {
      commit('setPlantPending', true)
      let pictureName = state.plant.id
      var uploadTask = fb.firebase
        .storage()
        .ref("/plantPictures")
        .child(pictureName)
        .putString(picture, "data_url");
      uploadTask.on(
        "state_changed",
        function(snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case fb.firebase.storage.TaskState.PAUSED: // or 'paused'
              // console.log("Upload is paused");
              break;
            case fb.firebase.storage.TaskState.RUNNING: // or 'running'
              // console.log("Upload is running");
              break;
          }
        },
        function(error) {
          // Handle unsuccessful uploads
        },
        function() {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            dispatch("updatePlant", {pictureUrl: downloadURL, pictureName })
            
          });
        }
      );
    },
    
  }
}
  